import { havingEditPermission } from "@/utility/common";
import { useTranslation } from "react-i18next";

const useHeaderDefinitions = (UserCaseGroup:string[]) => {
  const { t } = useTranslation();
  const caselistcolheader = [
    {
      suppressHeaderMenuButton: true,
      field: "userName",
      type:"userNameType",
      headerName: t("pages.caseSummary.fieldLabelDetails.teamMember"),
      sortable: true,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      flex: 3,
      minWidth: 150,
    },
    {
      field: "role",
      type:"roleType",
      headerName: t("pages.caseSummary.fieldLabelDetails.role"),
      flex: 3,
      sortable: true,
      unSortIcon: true,
      editable: havingEditPermission(UserCaseGroup),
      cellEditor: "agSelectCellEditor",
      cellEditorParams: (e: any) => {
        return {
          values: [t("pages.caseSummary.fieldLabelDetails.caseViewer"), t("pages.caseSummary.fieldLabelDetails.caseContributor"), t("pages.caseSummary.fieldLabelDetails.caseManager")],
        };
      },
      minWidth: 150,

    },
    {
      cellRenderer: "actionCellRenderers",
      field: "",
      flex: 2,
      headerName: "",
      sortable: false,
      editable: false,
      suppressCellFocus: true,
      suppressHeaderMenuButton: true,
      resizable: false,
      cellClass: 'align-right',
      minWidth: 100,

    },
  ];
  return caselistcolheader;
};
export default useHeaderDefinitions;
export const useSummaryHeaderDefinitions = () => {
  const { t } = useTranslation();
  const caselistcolheader = [
    {
      suppressHeaderMenuButton: true,
      field: "userName",
      type:"userNameType",
      headerName: t("pages.caseSummary.fieldLabelDetails.teamMember"),
      sortable: true,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      flex: 3,
    },
    {
      field: "role",
      type:"roleType",
      headerName: t("pages.caseSummary.fieldLabelDetails.role"),
      flex: 3,
      sortable: true,
      unSortIcon: true,
      editable: false,
    
    }
  ];
  return caselistcolheader;
};
